const loadGoogleMapsApi = require('load-google-maps-api');
class Map {

  static loadGoogleMapsApi() {
    return loadGoogleMapsApi({ key: 'AIzaSyD-xkubTeiinT0xitkQ2U4CthHKWcpt-Hc' });
  }

  static createMap(googleMaps, mapElement, latLng = { lat: 50.695041, lng: 5.250063 }, zoom = 14) {
    return new googleMaps.Map(mapElement, {
      center: latLng,
      zoom: zoom,
	  scrollwheel: false,
    });
  }

  static addMarker(googleMaps, map, markerInfo){
    return new googleMaps.Marker({
      position: { lat: markerInfo.latitude, lng: markerInfo.longitude },
      map: map,
      title: markerInfo.title,
      icon: {
        path: "M20,0C9,0,0,9,0,20s20,32,20,32s20-21,20-32S31,0,20,0z M20,28c-5.5,0-10-4.5-10-10S14.5,8,20,8s10,4.5,10,10 S25.5,28,20,28z M20,12c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,12,20,12z",
        scale: 0.70,				
        strokeOpacity: 0,
        fillColor: markerInfo.color,
        fillOpacity: 1,
        scrollwheel: false,
        anchor: {
          x: 18,
          y: 50
        }
      }
    });
  }
}

export { Map };